export const siteCompareFn = (a, b, i18n) => {
    const nameA = i18n.translatable(a.name);
    const nameB = i18n.translatable(b.name);
    if (!nameA || !nameB)
        return 0;
    if (nameA < nameB)
        return -1;
    if (nameA > nameB)
        return 1;
    return 0;
};
//# sourceMappingURL=site-utils.js.map